module.exports = __webpack_public_path__ + "static/img/abH3.4c3a9c00.png";